// event related unstable prefixes
// don't import this file directly, import '$unstable/prefixes'

/**
 * unstable prefix for blur hashes
 */
export const MATRIX_UNSTABLE_BLUR_HASH_PROPERTY_NAME = 'xyz.amorgan.blurhash';
/**
 * unstable prefix for media spoilers
 * defined in MSC4193 https://github.com/matrix-org/matrix-spec-proposals/pull/4193
 */
export const MATRIX_UNSTABLE_SPOILER_PROPERTY_NAME = 'page.codeberg.everypizza.msc4193.spoiler';
/**
 * unstable prefix for media spoilers reasons
 * defined in MSC4193 https://github.com/matrix-org/matrix-spec-proposals/pull/4193
 */
export const MATRIX_UNSTABLE_SPOILER_REASON_PROPERTY_NAME =
  'page.codeberg.everypizza.msc4193.spoiler.reason';
/**
 * unstable prefix for image pack references
 * defined in MSC4459 https://github.com/matrix-org/matrix-spec-proposals/pull/4259
 */
export const MATRIX_UNSTABLE_IMAGE_SOURCE_PACK_PROPERTY_NAME =
  'com.beeper.msc4459.image_source_packs';
/**
 * unstable prefix for per-message profiles
 * defined in MSC4144 https://github.com/matrix-org/matrix-spec-proposals/pull/4144
 */
export const MATRIX_UNSTABLE_PER_MESSAGE_PROFILE_PROPERTY_NAME = 'com.beeper.per_message_profile';
/**
 * unstable prefix for embedded link previews
 */
export const MATRIX_UNSTABLE_EMBEDDED_LINK_PREVIEW_PROPERTY_NAME = 'com.beeper.linkpreviews';

/**
 * unstable prefix for message forwards meta
 * defined in MSC2723 https://github.com/matrix-org/matrix-spec-proposals/pull/2723
 */
export const MATRIX_UNSTABLE_MESSAGE_FORWARD_META_PROPERTY_NAME = 'com.famedly.app.forwarded';
